(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    const form = root.querySelector('form');
    if (!form) return;
    root.dataset.initialized = 'true';
    const advice = () => form.querySelector('[data-material="advice"]');
    function update(event) {
      const model = form.querySelector('[data-model]:checked')?.dataset.model || 'advice';
      const overflow = form.querySelector('#AR-pooltype')?.value === 'Überlaufbecken';
      root.querySelector('[data-overflow-note]').hidden = !overflow;
      for (const input of form.querySelectorAll('[data-material]')) {
        const unavailable = (overflow && ['pvc', 'midgrey'].includes(input.dataset.material)) || (input.dataset.material === 'midgrey' && model !== '300');
        input.disabled = unavailable;
        input.closest('label').hidden = unavailable;
        if (unavailable && input.checked) { input.checked = false; advice().checked = true; }
      }
      for (const field of form.querySelectorAll('[data-models]')) {
        const visible = field.dataset.models === model;
        field.hidden = !visible;
        field.querySelectorAll('input,select').forEach(input => input.disabled = !visible);
      }
      for (const field of form.querySelectorAll('[data-frame-model]')) {
        const visible = field.dataset.frameModel === model;
        field.hidden = !visible;
        field.querySelectorAll('input').forEach(input => {
          input.disabled = !visible;
          if (!visible && input.checked) {
            input.checked = false;
            form.querySelector('[name="contact[Gestellfarbe]"][value="Bitte beraten"]').checked = true;
          }
        });
      }
      root.querySelector('[data-frame-advice]').hidden = model !== 'advice';
      for (const field of form.querySelectorAll('[data-option]')) {
        const supported = ['remote', 'bluetooth'].includes(field.dataset.option) ? ['100', '300'].includes(model) : model === '300';
        field.hidden = !supported;
        const input = field.querySelector('input');
        input.disabled = !supported;
        if (!supported) input.checked = false;
      }
      const changedOption = event?.target?.closest('[data-option]')?.dataset.option;
      if (event?.target?.checked && ['remote', 'bluetooth'].includes(changedOption)) {
        form.querySelector(`[data-option="${changedOption === 'remote' ? 'bluetooth' : 'remote'}"] input`).checked = false;
      }
      const bank = form.querySelector('#AR-bank');
      const wood = form.querySelector('[data-option="wood"] input');
      if (event?.target === bank) wood.checked = bank.value === 'PVC-Holzoptik – Aufpreis';
      if (event?.target === wood) bank.value = wood.checked ? 'PVC-Holzoptik – Aufpreis' : 'Bitte beraten';
      for (const input of form.querySelectorAll('[data-measure]')) {
        const number = Number(input.value.replace(',', '.'));
        input.setCustomValidity(input.value && (!(number > 0) || number > 50) ? root.dataset.invalidMeasure : '');
      }
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
    window.addEventListener('pageshow', () => update());
    update();
  }
  document.querySelectorAll('[data-ap-roll-enquiry]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ap-roll-enquiry]').forEach(init));
})();
